export default {
  customerLocationTimes: [],
  customerLocationTime: undefined,
};
